import { useState, type FormEvent } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/da2k37iamq5jpe1hrul0';

const quickLinks = [
  { href: '#featured', label: '热门推荐' },
  { href: '#campus', label: '校园系列' },
  { href: '#cohab', label: '同居系列' },
  { href: '#ambi', label: '暧昧系列' },
  { href: '#rev', label: '逆后宫系列' },
  { href: '#guide', label: '阅读指南' },
];

const categories = ['校园恋爱', '同居日常', '暧昧拉扯', '逆后宫'];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = String(formData.get('website_alt') ?? '').trim();
    setStatus('loading');

    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功，感谢关注！');
      form.reset();
      setEmail('');
      return;
    }

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt' && value) payload.append(key, String(value));
      });

      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.message || parsed?.code || '';
      if (
        res.ok &&
        parsed?.code === 'OK' &&
        !/spam|form data is spam/i.test(responseText + serverMsg)
      ) {
        setStatus('success');
        setMessage('订阅成功，我们会第一时间推送新作品。');
        form.reset();
        setEmail('');
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试。');
    }
  };

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#home" className="mb-4 flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-heart-3-fill text-lg" />
              </span>
              <span className="font-label text-xl">羞羞动漫漫画</span>
            </a>
            <p className="text-sm leading-relaxed text-background-200">
              一站式恋爱后宫漫画聚合站，围绕校园、同居、暧昧、逆后宫整理高口碑作品，让找漫画这件事变得简单。
            </p>
            <div className="mt-5 flex gap-3">
              {['ri-twitter-x-line', 'ri-wechat-line', 'ri-qq-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#about"
                  aria-label="社交媒体链接"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-800/60 text-background-100 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="快速导航">
            <h3 className="mb-4 text-base font-semibold text-background-50">快速导航</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="作品分类">
            <h3 className="mb-4 text-base font-semibold text-background-50">作品分类</h3>
            <ul className="space-y-2.5">
              {categories.map((item) => (
                <li key={item}>
                  <a href="#featured" className="text-sm text-background-200 transition-colors hover:text-accent-300">
                    {item}漫画
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="mb-4 text-base font-semibold text-background-50">订阅更新</h3>
            <p className="mb-4 text-sm leading-relaxed text-background-200">
              留下邮箱，第一时间获取新整理的恋爱后宫漫画推荐。
            </p>
            <form
              id="newsletter-subscribe"
              data-readdy-form="newsletter-subscribe"
              className="flex flex-col gap-3"
              onSubmit={handleSubmit}
            >
              <label className="sr-only" htmlFor="subscribe-email">
                电子邮箱
              </label>
              <input
                id="subscribe-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="你的邮箱地址"
                className="rounded-md border border-primary-700 bg-primary-900/60 px-4 py-2.5 text-sm text-background-50 placeholder:text-background-400 focus:border-accent-400 focus:outline-none focus:ring-2 focus:ring-accent-400/40"
              />
              <label className="sr-only" htmlFor="subscribe-suggest">补充信息</label>
              <input
                id="subscribe-suggest"
                name="website_alt"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="site-contact-suggest"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 disabled:opacity-60"
              >
                {status === 'loading' ? (
                  <>
                    <i className="ri-loader-4-line animate-spin" />
                    提交中
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line" />
                    订阅更新
                  </>
                )}
              </button>
              {status === 'success' && (
                <p className="flex items-center gap-1.5 text-sm text-accent-300">
                  <i className="ri-checkbox-circle-fill" />
                  {message}
                </p>
              )}
              {status === 'error' && (
                <p className="flex items-center gap-1.5 text-sm text-primary-200">
                  <i className="ri-error-warning-fill" />
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-background-300 md:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 羞羞动漫漫画 · 恋爱后宫漫画聚合站</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-line" />
            联系邮箱：hello@xiuxiumanga.example
          </p>
        </div>
      </div>
    </footer>
  );
}